<template>
  <div v-if="question.isShow" class="question-item">
    <div class="question-title">
      <i v-if="question.tipColor == 1">
        <img src="./image/red.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 2">
        <img src="./image/yellow.png" alt="">
      </i>
      <i v-else-if="question.tipColor == 3">
        <img src="./image/green.png" alt="">
      </i>
      <i v-if="question.isMust">*</i><span>第{{ question.serialNumber }}题：</span>{{ question.title }}
    </div>
    <div v-if="question.note" class="question-note">说明：{{ question.note }}</div>
    <img class="qs-img-preview" :src="question.pictureUrl" alt="">
    <div>
      <div v-for="(item,index) in question.options" :key="index">
        <div v-if="item.optionTitle == '准确值' && !question.numericTypeConfig.isOpenFrequency" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">准确值</span>
          <div v-if="item.selected" class="number-item number-item-common">
            <input v-model="question.value.firstValue" @input="restrictInput('firstValue')" type="number"
                   placeholder="请输入">
            <span style="padding: 5px 4px;border-left: 1px solid #ccc" v-if="question.numericTypeConfig.unitType.indexOf(',') == -1">{{question.value.unit}}</span>
            <el-select v-else v-model="question.value.unit" placeholder="单位" style="width: 100px;" size="mini">
              <el-option v-for="(it,ind) in unitListAfter" :key="ind" :label="it.value" :value="it.value"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="item.optionTitle == '范围值' && !question.numericTypeConfig.isOpenFrequency" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">范围值</span>
          <div v-if="item.selected" class="number-item-range number-item-common">
            <div style="display:flex;align-items: center;justify-content: space-between">
              <input v-model="question.value.firstValue" @input="restrictInput('firstValue')" type="number"
                     placeholder="请输入">
              <span style="margin-right: 25px;">~</span>
              <input v-model="question.value.secondValue" @change="checkHandler" @input="restrictInput('secondValue')"
                     type="number"
                     placeholder="请输入">
            </div>
            <span style="padding: 5px 4px;border-left: 1px solid #ccc" v-if="question.numericTypeConfig.unitType.indexOf(',') == -1">{{question.value.unit}}</span>
            <el-select v-else v-model="question.value.unit" placeholder="单位" style="width: 100px;" size="mini">
              <el-option v-for="(it,ind) in unitListAfter" :key="ind" :label="it.value" :value="it.value"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="item.optionTitle == '准确时长'" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">准确时长</span>
          <div v-if="item.selected" class="number-item number-item-common">
            <input v-model="question.value.firstValue" @input="restrictInput('firstValue')" type="number"
                   placeholder="请输入">
            <span style="padding: 5px 4px;border-left: 1px solid #ccc" v-if="question.numericTypeConfig.unitType.indexOf(',') == -1">{{question.value.unit}}</span>
            <el-select v-else v-model="question.value.unit" placeholder="单位" style="width: 100px;" size="mini">
              <el-option v-for="(it,ind) in unitListAfter" :key="ind" :label="it.value" :value="it.value"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="item.optionTitle == '范围时间'" class="option-item-timeRange">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">范围时间</span>
          <div v-if="item.selected" style="margin-left: 35px;">
            <time-picker :timeRange="question.value.timeRange"></time-picker>
          </div>
        </div>
        <div v-if="item.optionTitle == '范围时长'" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">范围时长</span>
          <div v-if="item.selected" class="number-item-range number-item-common">
            <div style="display:flex;align-items: center;justify-content: space-between">
              <input v-model="question.value.firstValue" @input="restrictInput('firstValue')" type="number"
                     placeholder="请输入">
              <span style="margin-right: 25px;">~</span>
              <input v-model="question.value.secondValue" @change="checkHandler" @input="restrictInput('secondValue')"
                     type="number"
                     placeholder="请输入">
            </div>
            <span style="padding: 5px 4px;border-left: 1px solid #ccc" v-if="question.numericTypeConfig.unitType.indexOf(',') == -1">{{question.value.unit}}</span>
            <el-select v-else v-model="question.value.unit" placeholder="单位" style="width: 100px;" size="mini">
              <el-option v-for="(it,ind) in unitListAfter" :key="ind" :label="it.value" :value="it.value"></el-option>
            </el-select>
          </div>
        </div>
        <div v-if="item.optionTitle == '准确值' && question.numericTypeConfig.isOpenFrequency" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">准确值</span>
          <div v-if="item.selected" class="number-item-time number-item-common">
            <input v-model="question.value.firstValue" @input="restrictInput('firstValue')" type="number"
                   placeholder="请输入">
            <div>
              <span style="padding: 5px 4px;border-left: 1px solid #ccc" v-if="question.numericTypeConfig.unitType.indexOf(',') == -1">{{question.value.unit}}</span>
              <el-select v-else v-model="question.value.unit" placeholder="单位" style="width: 100px;" size="mini">
                <el-option v-for="(it,ind) in unitListAfter" :key="ind" :label="it.value" :value="it.value"></el-option>
              </el-select>
              <el-select v-model="question.value.frequency" placeholder="频次" style="width: 80px;" size="mini">
                <el-option v-for="(it,ind) in frequencyList" :key="ind" :label="it.label" :value="it.value"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div v-if="item.optionTitle == '范围值' && question.numericTypeConfig.isOpenFrequency" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">范围值</span>
          <div v-if="item.selected" class="number-item-range-time number-item-common">
            <div style="display:flex;align-items: center;justify-content: space-between">
              <input v-model="question.value.firstValue" @input="restrictInput('firstValue')" type="number"
                     placeholder="请输入">
              <span style="margin-right: 25px;">~</span>
              <input v-model="question.value.secondValue" @change="checkHandler" @input="restrictInput('secondValue')"
                     type="number"
                     placeholder="请输入">
            </div>
            <div>
              <span style="padding: 5px 4px;border-left: 1px solid #ccc" v-if="question.numericTypeConfig.unitType.indexOf(',') == -1">{{question.value.unit}}</span>
              <el-select v-else v-model="question.value.unit" placeholder="单位" style="width: 100px;" size="mini">
                <el-option v-for="(it,ind) in unitListAfter" :key="ind" :label="it.value" :value="it.value"></el-option>
              </el-select>
              <el-select v-model="question.value.frequency" placeholder="频次" style="width: 80px;" size="mini">
                <el-option v-for="(it,ind) in frequencyList" :key="ind" :label="it.label" :value="it.value"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div v-if="item.optionTitle == '其他'" class="option-item">
          <i v-if="!item.selected" @click="selectHandler(item)" class="iconfont iconselect-normal"></i>
          <i v-if="item.selected" @click="selectHandler(item)" class="iconfont iconselect-active"></i>
          <span style="display: inline-block;width: 70px;">其他</span>
          <input v-if="item.selected" v-model="question.value.other" class="other-input" placeholder="请输入"
                 style="font-size:14px;padding: 5px 10px;margin-left: 25px;border: 1px solid #ccc;border-radius: 5px"
                 type="text">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/style/editor/quill.core.css'
import timePicker from './dateTimePickerRange'
export default {
  name: 'question-numberValue',
  props: {
    question: {required: true},
  },//
  data() {
    return {
      value: {
        title: '准确值',
        firstValue: "",
        secondValue: "",
        timeRange: [
          {
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: '',
          }, {
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: '',
          }],
        unit: "g",
        frequency: "每天",
      },
      frequencyList: [
        {label: '每天', value: 1},
        {label: '每周', value: 2},
        {label: '每月', value: 3},
        {label: '每年', value: 4},
      ],
      question1: {
        value: {
          timeRange: [
            {
              yearSelect: '',
              monthSelect: '',
              daySelect: '',
              hourSelect: '',
              minuteSelect: '',
            }, {
              yearSelect: '',
              monthSelect: '',
              daySelect: '',
              hourSelect: '',
              minuteSelect: '',
            }]
        }
      },
      currentIndex: null,
      fileList: [],
      uploader: [],
      imageList: [],
      jumpPageNumber: null,
      show: false,
      unitList: [
        {
          label: '时间',
          value: 'selectedTime',
          children: [
            {label: '秒', value: '秒'},
            {label: '分钟', value: '分钟'},
            {label: '小时', value: '小时'},
            {label: '天', value: '天'},
            {label: '周', value: '周'},
            {label: '月', value: '月'},
            {label: '年', value: '年'},
          ]
        },
        {
          label: '重量',
          value: '重量',
          children: [
            {label: '斤', value: '斤'},
            {label: '公斤', value: '公斤'},
            {label: '克', value: '克'},
            {label: '千克', value: '千克'},
            {label: '毫克', value: '毫克'},
            {label: '吨', value: '吨'},
          ]
        },
        {
          label: '长度',
          value: '长度',
          children: [
            {label: '米', value: '米'},
            {label: '厘米', value: '厘米'},
            {label: '毫米', value: '毫米'},
            {label: '千米', value: '千米'},
            {label: '英寸', value: '英寸'},
            {label: '英尺', value: '英尺'},
          ]
        },
        {
          label: '面积',
          value: '面积',
          children: [
            {label: '平方米', value: '平方米'},
            {label: '平方厘米', value: '平方厘米'},
            {label: '平方毫米', value: '平方毫米'},
          ]
        },
        {
          label: '体积',
          value: '体积',
          children: [
            {label: '升', value: '升'},
            {label: '毫升', value: '毫升'},
            {label: '立方米', value: '立方米'},
            {label: '立方厘米', value: '立方厘米'},
            {label: '立方毫米', value: '立方毫米'},
          ]
        },
        {
          label: '温度',
          value: '温度',
          children: [
            {label: '摄氏度', value: '摄氏度'},
            {label: '华氏度', value: '华氏度'},
          ]
        },
        {
          label: '能量',
          value: '能量',
          children: [
            {label: '焦', value: '焦'},
            {label: '千焦', value: '千焦'},
            {label: '卡', value: '卡'},
            {label: '大卡', value: '大卡'},
          ]
        },
        {
          label: '自定义',
          value: '自定义',
        }
      ],
      unitListAfter: []
    }
  },
  created() {
    this.getUnitList()
    this.getPicture()
    this.getAnswer()
  },
  watch: {},//
  components: {
    timePicker
  },
  methods: {
    checkHandler() {
      console.log(111);
      if (this.question.value.secondValue * 1 < this.question.value.firstValue * 1) {
        this.$message.error('前后值有误')
        this.$set(this.question.value, 'secondValue', "")
        this.$forceUpdate()
      }
    },
    getAnswer() {
      if (this.question.hasOwnProperty('answerInfo') && this.question.answerInfo != '') {
        let answerInfo = JSON.parse(this.question.answerInfo)
        this.$delete(this.question, 'value')
        this.$set(this.question, 'value',answerInfo)
        this.question.options.forEach((item, index) => {
          if (item.id === this.question.value.optionId) {
            item.selected = true
          }
        })
        if(!answerInfo.hasOwnProperty('firstValue')) {
          this.question.value = {
            title: '',
            firstValue: "",
            secondValue: "",
            timeRange: [
              {
                yearSelect: '',
                monthSelect: '',
                daySelect: '',
                hourSelect: '',
                minuteSelect: '',
              }, {
                yearSelect: '',
                monthSelect: '',
                daySelect: '',
                hourSelect: '',
                minuteSelect: '',
              }],
            unit: this.question.numericTypeConfig.unitType.indexOf(',') != -1 ? this.question.numericTypeConfig.unitType.split(',')[1] : this.question.numericTypeConfig.unitType,
            frequency: this.question.numericTypeConfig.frequencyType,
            optionId: "",
            other: ""
          }
        }
        // this.question.value.unit = this.question.numericTypeConfig.unitType.indexOf(',') == -1 ? this.question.value.unit : this.question.numericTypeConfig.unitType.split(',')[1]
      } else {
        this.question.value = {
          title: '',
          firstValue: "",
          secondValue: "",
          timeRange: [
            {
              yearSelect: '',
              monthSelect: '',
              daySelect: '',
              hourSelect: '',
              minuteSelect: '',
            }, {
              yearSelect: '',
              monthSelect: '',
              daySelect: '',
              hourSelect: '',
              minuteSelect: '',
            }],
          unit: this.question.numericTypeConfig.unitType.indexOf(',') != -1 ? this.question.numericTypeConfig.unitType.split(',')[1] : this.question.numericTypeConfig.unitType,
          frequency: this.question.numericTypeConfig.frequencyType,
          optionId: "",
          other: ""
        }

      }
    },
    selectHandler(qs) {
      if(qs.selected) {
        qs.selected = false
        this.question.value = {
          title: '',
          firstValue: "",
          secondValue: "",
          timeRange: [
            {
              yearSelect: '',
              monthSelect: '',
              daySelect: '',
              hourSelect: '',
              minuteSelect: '',
            }, {
              yearSelect: '',
              monthSelect: '',
              daySelect: '',
              hourSelect: '',
              minuteSelect: '',
            }],
          unit: this.question.numericTypeConfig.unitType.indexOf(',') != -1 ? this.question.numericTypeConfig.unitType.split(',')[1] : this.question.numericTypeConfig.unitType,
          frequency: this.question.numericTypeConfig.frequencyType,
          optionId: "",
          other: ""
        }
      }else {
        this.question.options.forEach((item, index) => {
          item.selected = false
        })
        qs.selected = true
        this.question.value.title = qs.optionTitle
        this.question.value.optionId = qs.id
      }

    },
    restrictInput(key) {
      if (this.question.value[key] < 0) {
        this.question.value[key] = 0
      }
    },
    checkIsFill() {
      return true
    },
    saveAnswer() {
    },//
    getPicture() {
      if (this.question.pictureUrl) {
        this.$store.dispatch('getPicture', {url: [this.question.pictureUrl]})
            .then(res => {
              this.question.pictureUrl = res[0]
            })
      }
    },//
    getUnitList() {
      let key = this.question.numericTypeConfig.unitType.indexOf(',') ? this.question.numericTypeConfig.unitType.split(',')[0] : this.question.numericTypeConfig.unitType
      console.log(key, this.unitList.find(item => item.value == key));
      if (key && this.unitList.find(item => item.value == key)) {
        this.unitListAfter = this.unitList.find(item => item.value == key).children
      }
    },
    getUnitKey() {
    }
  }
} //
</script>
<style lang="scss">
.option-item {
  .el-input--mini .el-input__inner {
    border-radius: 0;
    border: none;
    border-left: 1px solid #ccc;
  }
}

//
</style>
<style lang="scss" scoped>
@import "questionCommon";

.option-item, {
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  .iconfont {
    margin-right: 10px;
    text-align: center;
  }
}

.option-item-timeRange {
  margin-bottom: 20px;

  .iconfont {
    margin-right: 10px;
    text-align: center;
  }
}

.other-input {
  padding: 2px 0;
}

.number-item {
  width: 250px;
}

.number-item-time {
  width: 330px;
}

.number-item-range {
  width: 350px;
}

.number-item-range-time {
  width: 430px;
}

//
.number-item-common {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-left: 25px;
  padding: 2px 0 2px 10px;
  font-size: 14px;
  justify-content: space-between;

  input {
    border: none;
    width: 60px;
    font-size: 14px;
  }
}

.question-option {
  .option-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-size: 16px;
      margin-left: 10px;
    }
  }//

  .option-other {

  }
}
</style>